import useMountEffect from '@restart/hooks/useMountEffect';
import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { MdOutlineClose } from 'react-icons/md';

import styles from './NotifierContainer.module.scss';
import { setHandler } from './NotifierService';

const cx = classNames.bind(styles);

const NotifierContainer = () => {
  const [notifications, setNotifications] = useState([]);
  const [containerStyle, setContainerStyle] = useState({});

  useMountEffect(() => {
    setHandler(addNotification);
  });

  // 새로운 알림 추가
  // options: { top?: number, duration?: number }
  const addNotification = (type, text, options = {}) => {
    const id = Date.now();
    let duration = 5000; // 기본 표시 시간: 5초

    // 커스텀 duration 설정
    if (options.duration !== undefined) {
      duration = options.duration;
    }

    const notification = { id, type, text, duration };

    setNotifications((prev) => [...prev, notification]);

    // 커스텀 top 위치 설정 (예: 로그인 페이지에서 상단에 가깝게 표시)
    if (options.top !== undefined) {
      setContainerStyle({ top: `${options.top}px` });
    }

    // 지정된 시간 후 자동 제거
    setTimeout(() => {
      removeNotification(id);
    }, duration);
  };

  // 알림 제거
  const removeNotification = (targetId) => {
    setNotifications((prev) => {
      // 해당 ID의 알림을 제거
      const filtered = prev.filter(({ id }) => id !== targetId);

      // 모든 알림이 제거되면 커스텀 스타일 초기화 (기본 top: 96px로 복원)
      if (filtered.length === 0) {
        setContainerStyle({});
      }

      return filtered;
    });
  };

  if (notifications.length === 0) return;

  return (
    <div className={cx('container')} style={containerStyle}>
      {notifications.map(({ id, type, text, duration }) => (
        <div key={id} className={cx(['notification', type])}>
          <div className={cx('content')}>
            <span className={cx('text')}>{text}</span>
            <div className={cx('remove')} onClick={() => removeNotification(id)}>
              <MdOutlineClose size={16} color="white" />
            </div>
          </div>
          <div className={cx(['progress', type])} style={{ animationDuration: `${duration}ms` }} />
        </div>
      ))}
    </div>
  );
};

export default NotifierContainer;
